/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopFilters_viewer" | "SbRespRefineMenuDrawer_viewer">;
    readonly " $refType": "SbRespRefineTopNav_viewer";
};
export type SbRespRefineTopNav_viewer$data = SbRespRefineTopNav_viewer;
export type SbRespRefineTopNav_viewer$key = {
    readonly " $data"?: SbRespRefineTopNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopNav_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopFilters_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '93f7016f5253400531866e891b2370fd';
export default node;
